import { ThemeProvider, createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#09A0F2",
      main: "#09A0F2",
      dark: "#09A0F2",
      // contrastText: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      // contrastText: "#000",
    },
  },
});
